import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center mb-4">
              <img
                src="https://customer-assets.emergentagent.com/job_industrial-supply-20/artifacts/skys35hx_SSA_FULL_.png"
                alt="SSA Distribuidora"
                className="h-12 w-auto" />

            </div>
            <p className="!text-sm text-gray-400">Soluções profissionais para o mercado de autopeças automotivo e MRO. Garantindo continuidade operacional.

            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold mb-4 text-lg">Navegação</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('sobre')}
                  className="text-gray-400 hover:text-red-500 transition-colors duration-200">

                  Sobre a SSA
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('proposito')}
                  className="text-gray-400 hover:text-red-500 transition-colors duration-200">

                  Nosso Propósito
                </button>
              </li>
              <li>
                <a
                  href="https://www.vhsys.net/ssadistribuidora"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-red-400 hover:text-red-300 transition-colors duration-200 font-semibold flex items-center gap-1">

                  🛒 Loja Virtual
                </a>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contato')}
                  className="text-gray-400 hover:text-red-500 transition-colors duration-200">

                  Contato
                </button>
              </li>
              <li>
                <Link
                  to="/garantia"
                  className="text-gray-400 hover:text-red-500 transition-colors duration-200">
                  Política de Garantia
                </Link>
              </li>
            </ul>
          </div>

          {/* Products */}
          <div>
            <h3 className="text-white font-bold mb-4 text-lg">Categorias</h3>
            <ul className="space-y-2 text-sm">
              <li className="text-gray-400">Linha Automotiva</li>
              <li className="text-gray-400">Peças Técnicas</li>
              <li className="text-gray-400">Sob Demanda</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-bold mb-4 text-lg">Contato</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start">
                <MapPin className="text-red-500 mr-2 flex-shrink-0 mt-1" size={16} />
                <span className="text-gray-400">
                  Rod. Washington Luiz, s/n<br />
                  Jardim Gramacho - Duque de Caxias - RJ
                </span>
              </li>
              <li className="flex items-center">
                <Phone className="text-red-500 mr-2 flex-shrink-0" size={16} />
                <a href="tel:+5521996772772" className="text-gray-400 hover:text-red-500 transition-colors">+55 (21) 99677-2772

                </a>
              </li>
              <li className="flex items-center">
                <Mail className="text-red-500 mr-2 flex-shrink-0" size={16} />
                <a href="mailto:vendas@ssapecas.com.br" className="text-gray-400 hover:text-red-500 transition-colors break-all">vendas@ssapecas.com.br</a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-400">
              &copy; {currentYear} SSA Distribuidora. Todos os direitos reservados.
            </p>
            <p className="text-sm text-gray-400 italic">
              "Onde outros veem metal, nós enxergamos propósito em continuidade"
            </p>
          </div>
        </div>
      </div>
    </footer>);

};